import React, { useState } from 'react';
import { Button } from '../base/Button';
import { useLocation } from 'react-router-dom';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: '首頁', path: '/' },
    { name: '服務項目', path: '/#services' },
    { name: '申請流程', path: '/#process' },
    { name: '常見問題', path: '/#faq' },
    { name: '香港移民計劃', path: '/hk-immigration' },
    { name: '聯絡我們', path: '/#contact' },
  ];

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/7a5b040bfff3a0cfc0bcd3a8224a4496/2c654adcd385f5d841e14a9cbf53bc1e.png" 
              alt="萬業人才資本 Omni Workforce" 
              className="h-10 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            {navItems.map((item) => (
              <a 
                key={item.path}
                href={item.path} 
                className="text-gray-700 hover:text-green-600 transition-colors"
              >
                {item.name}
              </a>
            ))}
            <a 
              href="tel:+85293663961" 
              className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap bg-green-600 hover:bg-green-700 text-white shadow-lg hover:shadow-xl px-4 py-2 text-sm"
            >
              立即致電諮詢
            </a>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-green-600 focus:outline-none"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <a 
                  key={item.path}
                  href={item.path} 
                  className="text-gray-700 hover:text-green-600 transition-colors"
                >
                  {item.name}
                </a>
              ))}
              <a 
                href="tel:+85293663961" 
                className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap bg-green-600 hover:bg-green-700 text-white shadow-lg hover:shadow-xl px-4 py-2 text-sm w-fit"
              >
                立即致電諮詢
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
